module.exports = __webpack_public_path__ + "img/linkedin-icon.cb54c790.png";